module.exports = __webpack_public_path__ + "media/components/insights/asset-icons/facilities-a2e7a9fc7d0c1cbff40b4824a5d86e61.png";